import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "competition-standings-filter" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]

import { PropType } from 'vue'

export interface ActiveFilterOpts {
  category: string
  index: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CompetitionStandingsFilter',
  props: {
  rules: {
    type: Array as PropType<string[]>,
    default: () => [],
  },

  teamSizes: {
    type: Array as PropType<string[]>,
    default: () => [],
  },

  activeFilter: {
    type: Object as PropType<ActiveFilterOpts | null>,
    required: true,
  },

  activeFilterDefaultIndex: {
    type: Number as PropType<number>,
    default: 0,
  },
},
  emits: ['select'],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.rules.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({ selected: __props.activeFilter.category === 'individual' }),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (
        _ctx.$emit('select', {
          category: 'individual',
          index: __props.activeFilterDefaultIndex,
        })
      ))
        }, _toDisplayString(_ctx.$t('competition-standings-filter.individual')), 3))
      : _createCommentVNode("", true),
    (__props.teamSizes.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass({ selected: __props.activeFilter.category === 'teams' }),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('select', { category: 'teams', index: 0 })))
        }, _toDisplayString(_ctx.$t('competition-standings-filter.teams')), 3))
      : _createCommentVNode("", true),
    (__props.rules.length + __props.teamSizes.length > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "•"))
      : _createCommentVNode("", true),
    (__props.activeFilter.category === 'individual')
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(__props.rules, (rule, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass({ selected: index === __props.activeFilter.index }),
            onClick: ($event: any) => (_ctx.$emit('select', { category: 'individual', index }))
          }, [
            _createElementVNode("span", null, _toDisplayString(rule), 1)
          ], 10, _hoisted_3))
        }), 128))
      : _createCommentVNode("", true),
    (__props.activeFilter.category === 'teams')
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(__props.teamSizes, (teamSize, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass({ selected: index === __props.activeFilter.index }),
            onClick: ($event: any) => (_ctx.$emit('select', { category: 'teams', index }))
          }, [
            _createElementVNode("span", null, _toDisplayString(teamSize), 1)
          ], 10, _hoisted_4))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}
}

})